<template>
  <b-form-group
    label="Mülk Tanımı"
    label-for="title"
  >
    <validation-provider
      #default="{ errors }"
      name="Mülk Tanımı"
      rules="required"
    >
      <b-form-input
        id="title"
        v-model="dataItem.title"
        placeholder="Mülk Tanımı"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup, BFormInput,
} from 'bootstrap-vue'
import { required } from '@validations'

export default {
  name: 'Title',
  components: {
    BFormGroup,
    BFormInput,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['estates/dataItem']
    },
  },
  created() {
    localize('tr')
  },
}
</script>
